import { useEffect, useCallback } from 'react'
import { RunningContext } from '../types/sdk'
import { useAppDispatch } from './useRTK'
import { setDialog } from '../app/dialog'

export const useOnCollaborateRequest = (
  runningContext: RunningContext | undefined
) => {
  const dispatch = useAppDispatch()
  const fn = useCallback(() => {
    dispatch(setDialog({ type: 'fileShareMS' }))
  }, [dispatch])

  useEffect(() => {
    // prevent zoomSdk warning
    if (runningContext && runningContext !== 'inMainClient') {
      try {
        zoomSdk.addEventListener('zmOnCollaborateRequest', fn)
      } catch {
        // do nothing to suppress warning
      }
    }

    return () => {
      if (runningContext && runningContext !== 'inMainClient') {
        try {
          zoomSdk.removeEventListener('zmOnCollaborateRequest', fn)
        } catch {
          // do nothing to suppress warning
        }
      }
    }
  }, [fn, runningContext])
}
